import styled from 'styled-components'

import { Table as AntTable } from 'src/components/Ant'

export const Table = styled(AntTable)`
  border-radius: 4px;
  margin: 0 16px 24px 16px;
`
